export default "__VITE_ASSET__B50pe4Vd__"